var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 1.5C0.25 1.08579 0.585786 0.75 1 0.75H19C19.4142 0.75 19.75 1.08579 19.75 1.5C19.75 1.91421 19.4142 2.25 19 2.25H1C0.585786 2.25 0.25 1.91421 0.25 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 6.5C0.25 6.08579 0.585786 5.75 1 5.75H15C15.4142 5.75 15.75 6.08579 15.75 6.5C15.75 6.91421 15.4142 7.25 15 7.25H1C0.585786 7.25 0.25 6.91421 0.25 6.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 11.5C0.25 11.0858 0.585786 10.75 1 10.75H19C19.4142 10.75 19.75 11.0858 19.75 11.5C19.75 11.9142 19.4142 12.25 19 12.25H1C0.585786 12.25 0.25 11.9142 0.25 11.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 16.5C0.25 16.0858 0.585786 15.75 1 15.75H15C15.4142 15.75 15.75 16.0858 15.75 16.5C15.75 16.9142 15.4142 17.25 15 17.25H1C0.585786 17.25 0.25 16.9142 0.25 16.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnHamburger);
export default __webpack_public_path__ + "static/media/icn-hamburger.4a60518a543cacb008de9e40c491532a.svg";
export { ForwardRef as ReactComponent };